import type { FunctionComponent } from 'react';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';
import { DottedOutlineCircleIcon } from '~/ui/core/icons';

import { StatusIndicator } from './StatusIndicator';

export const DraftBadge: FunctionComponent<{ readonly isActive?: boolean; readonly size?: 'sm' | 'md' }> = ({
    isActive = false,
    size = 'sm',
}) => {
    const { translate } = useContext(ApplicationContext);

    return (
        <StatusIndicator
            className={isActive ? 'text-white-200' : 'text-gray-700'}
            data-testid="review-state-draft"
            icon={<DottedOutlineCircleIcon height={12} width={12} />}
            size={size}
        >
            {translate('pages.job-architecture-v2.review-state.draft')}
        </StatusIndicator>
    );
};
